/**
 * @param array
 * @param item Object
 * @param key Object key
 * @returns {boolean}
 */
export function arrayContainsObj(array, item, key) {
  return array.filter(elem => elem[key] === item[key]).length > 0;
}

/**
 *
 * @param array
 * @param item
 * @param key
 * @returns {*}
 */
export function removeObjFromArray(array, item, key) {
  return array.filter(elem => elem[key] !== item[key]);
}

/**
 *
 * @param array
 * @param attribute
 * @param value
 * @returns {*}
 */
export function getObjByAttribute(array, attribute, value) {
  const results = array.filter(elem => elem[attribute] === value);
  return results.length > 0 ? results[0] : null;
}

/**
 *
 * @param array
 * @param attribute
 * @param value
 */
export function removeObjByAttribute(array, attribute, value) {
  return array.filter(elem => elem[attribute] !== value);
}


if (!Array.prototype.findLastIndex) {
  Array.prototype.findLastIndex = function (callback, thisArg) {
    for (let i = this.length - 1; i >= 0; i--) {
      if (callback.call(thisArg, this[i], i, this)) return i;
    }
    return -1;
  };
}
